import { MatOptAddressGroup } from "../address-autocomplete.component";
import { generateAddressSummary } from "@onsip/common/services/api/resources/addressSummary/generate-address-summary.helper";

export const ANNOUNCEMENTS_HANGUP_AOR = "Hangup after message plays";

export const ANNOUNCEMENTS_HANGUP_OPTIONS: MatOptAddressGroup = [
  {
    label: "",
    addresses: [
      generateAddressSummary({
        name: "Hangup after message plays",
        aor: ANNOUNCEMENTS_HANGUP_AOR
      })
    ]
  }
];
